import { useState, useContext } from 'react';
import { StyledBroadsiderInventory } from './BroadsiderInventory.styled';
import { BroadsiderInventoryItem, ExploreItems, SelectItem } from '../';
import { openUrl } from '../../utils';
import { AppContext } from '../../providers/AppContext';

const BroadsiderInventorySlot = ({ slot, isSelected = false, isShadowed = false, onSelect }) => {
  const { equipItem } = useContext(AppContext);
  const isExplore = !slot.options || slot.options.length < 1;
  const isSelect = !slot.equipped;

  const onClick = () => {
    if (isExplore) {
      onSelect(false);
      openUrl(slot.exploreUrl);
    } else {
      onSelect(!isSelected);
    }
  };

  if (isExplore) {
    return (
      <div className='broadsider-inv-slot' style={{ opacity: isShadowed ? '0.4' : '1.0' }}>
        <ExploreItems slot={slot} onClick={onClick} />
        <div className={`broadsider-inv-slot-decorator${isSelected ? ' broadsider-inv-slot-decorator-selected' : ''}`} />
        <div className={`broadsider-inv-slot-decorator-back ${isSelected ? ' broadsider-inv-slot-decorator-selected' : ''}`} />
      </div>
    );
  }

  if (isSelect) {
    return (
      <div className='broadsider-inv-slot' style={{ opacity: isShadowed ? '0.4' : '1.0' }}>
        <SelectItem slot={slot} onClick={onClick} isSelected={isSelected} />
        <div className={`broadsider-inv-slot-decorator${isSelected ? ' broadsider-inv-slot-decorator-selected' : ''}`} />
        <div className={`broadsider-inv-slot-decorator-back ${isSelected ? ' broadsider-inv-slot-decorator-selected' : ''}`} />
      </div>
    );
  }

  return (
    <div className='broadsider-inv-slot' style={{ opacity: isShadowed ? '0.4' : '1.0' }}>
      <BroadsiderInventoryItem item={slot.equipped} isSelected={isSelected} isSlot={true} slot={slot} onClick={onClick} />
      <div className={`broadsider-inv-slot-decorator${isSelected ? ' broadsider-inv-slot-decorator-selected' : ''}`} />
      <div className={`broadsider-inv-slot-decorator-back ${isSelected ? ' broadsider-inv-slot-decorator-selected' : ''}`}>
        <div className='broadsider-inv-slot-delete-button' onClick={() => equipItem(slot.equipped, false)}>
          X
        </div>
      </div>
    </div>
  );
};

const BroadsiderInventory = ({ inventory: { slots = [] }, selectedSlotIndex = -1, onSlotSelected = () => {} }) => {
  const onSelectSlot = (select, index) => {
    onSlotSelected(select ? index : -1);
  };

  return (
    <StyledBroadsiderInventory>
      <div className='broadsider-inv-content-wrapper'>
      <div className='broadsider-inv-content'>
        <div className='broadsider-inv-holder'>
          <div className='broadsider-inv-title-holder'>
            <img className='broadsider-inv-logo' src='/assets/skull.svg' />
            <div className='broadsider-inv-title'>Inventory</div>
            <div className='broadsider-inv-logo broadsider-inv-cube broadsider-inv-cube-row'>
              <div className='broadsider-inv-cube-col'>
                <div className={selectedSlotIndex === 0 ? 'selection' : undefined}/>
                <div className={selectedSlotIndex === 1 ? 'selection' : undefined}/>
              </div>
              <div className='broadsider-inv-cube-col'>
                <div className={selectedSlotIndex === 2 ? 'selection' : undefined}/>
                <div className={selectedSlotIndex === 3 ? 'selection' : undefined}/>
              </div>
            </div>
          </div>
          <div className='broadsider-inv-items'>
            {slots.map((s, index) => (<BroadsiderInventorySlot key={`inv-slot-${index}`} isShadowed={selectedSlotIndex >= 0 && index !== selectedSlotIndex} isSelected={index === selectedSlotIndex} slot={s} onSelect={(select) => onSelectSlot(select, index)}/>))}
          </div>
        </div>
      </div>
      </div>
      <div className='broadsider-inv-corner broadsider-inv-corner-tl' />
      <div className='broadsider-inv-corner broadsider-inv-corner-tr' />
      <div className='broadsider-inv-corner broadsider-inv-corner-bl' />
      <div className='broadsider-inv-corner broadsider-inv-corner-br' />
    </StyledBroadsiderInventory>
  )
};

export default BroadsiderInventory;
